import script from "./BuyAut.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyAut.vue?vue&type=script&setup=true&lang=js"

import "./BuyAut.vue?vue&type=style&index=0&id=452a8c0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452a8c0e"]])

export default __exports__